export default {"src":"/_next/static/media/water-resistance-icon-yes.2fe3520f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};